const getUpgradeBannerTranslations = descriptions => {
  const bannerTranslations = {
    bannerTitle: undefined,
    bannerSubtitle: undefined
  };
  if (descriptions && descriptions.length > 0) {
    descriptions.forEach(descriptionObj => {
      const {
        descriptionType,
        description
      } = descriptionObj;
      if (descriptionType === 'BANNER_TITLE') {
        bannerTranslations.bannerTitle = description;
      } else if (descriptionType === 'BANNER_SUBTITLE') {
        bannerTranslations.bannerSubtitle = description;
      }
    });
  }
  return bannerTranslations;
};
export default getUpgradeBannerTranslations;